import React from "react";
import styled from "styled-components";
import { useRouter } from "next/navigation";
import Link from "@motorata/next.components.atoms.link";
import NextLink from "next/link";
import { Box, Row } from "@motorata/base-ui.components.atoms._atoms";
import Alert from "@motorata/base-ui.components.molecules.alert";
import Icon from "@motorata/base-ui.components.atoms.icon";
import { H1, P } from "@motorata/base-ui.components.atoms.typography";
import Button, { IconButton } from "@motorata/base-ui.components.atoms.button";
import { findModel, translate, translateBrand, translateModel } from "@motorata/base-ui.data";
import { useShare } from "../../hooks/useShare";
import Dropdown from "../../components/common/Dropdown";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useFavourite } from "../../hooks/useFavourite";

const OfferContentHeader = ({ id, status, type, brand, model, version }) => {
  const router = useRouter();
  const { width } = useWindowSize();

  const { isFavourite, addOffer, deleteOffer } = useFavourite(id);
  const { handleCopyLink, handleShareWithFB, handleShareWithLinkedIn } = useShare(id);

  return (
    <>
      {status === "deactivate" && (
        <Box marginBottom="S">
          <Alert small type="warning">
            Ogłoszenie zostało zarchiwizowane i już nie jest aktywne. Zobacz aktualne ogłoszenia{" "}
            <NextLink href={type === "car" ? `/oferty/car/${brand}/${model}` : `/oferty/all/${brand}`}>tutaj</NextLink>.
          </Alert>
        </Box>
      )}
      <Box marginBottom="S">
        <Row alignItems="center" className="breadcrumbs">
          <Link type="third" href={`/oferty/${type}`} padding="0" marginRight="XS">
            {translate(type)}
          </Link>
          <Icon height="15px" width="15px" icon="arrow-right" />
          <Link type="third" href={`/oferty/${type}/${brand}`} padding="0" marginRight="XS" marginLeft="XS">
            {translateBrand(brand)}
          </Link>
          {
            findModel(brand, model) && findModel(brand, model)[0] !== "" &&
            <>
              <Icon height="15px" width="15px" icon="arrow-right" />
              <Link type="third" href={`/oferty/${type}/${brand}/${model}`} padding="0" marginRight="XS" marginLeft="XS">
                {translateModel(model)}
              </Link>
            </>
          }
        </Row>
      </Box>
      <StyledRow>
        <Box>
          <H1 margin="0">
            {`${translateBrand(brand)} ${translateModel(model)}`}
          </H1>
          <P color="third" margin="0">
            {version}
          </P>
        </Box>
        <Row alignItems="center">
          <Dropdown
            button={onCLick =>
              width < 700 ? (
                <IconButton
                  size="XL"
                  background="none"
                  onClick={onCLick}
                  icon="share"
                />
              ) : (
                <Button onClick={onCLick} icon="share" type="third" width="max-content">
                  Udostępnij
                </Button>
              )
            }
            options={[
              {
                icon: "copy",
                text: "Kopiuj link",
                onClick: handleCopyLink
              },
              {
                icon: "facebook",
                text: "Udostępnij na Facebook",
                onClick: handleShareWithFB
              },
              {
                icon: "linkedin",
                text: "Udostępnij na LinkedIn",
                onClick: handleShareWithLinkedIn
              }
            ]}
          />

          {width < 700 ? (
            <>
              <IconButton
                size="XL"
                background="none"
                color={isFavourite ? "primary" : "second"}
                onClick={!isFavourite ? () => addOffer(id) : () => deleteOffer(id)}
                icon={isFavourite ? "heart-fill" : "heart"}
              />
            </>
          ) : (
            <Button
              paddingRight="0 !important"
              // active={isFavourite}
              onClick={!isFavourite ? () => addOffer(id) : () => deleteOffer(id)}
              color={isFavourite ? "primary" : "second"}
              icon={isFavourite ? "heart-fill" : "heart"}
              type="third"
              width="max-content"
            >
              {isFavourite ? "Usuń z obserwowanych" : "Dodaj do obserwowanych"}
            </Button>
          )}
        </Row>
      </StyledRow>
    </>
  );
};

export default OfferContentHeader;

const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: ${({ theme }) => theme.space.S};
`;
